import { render, staticRenderFns } from "./TouristsSelector.vue?vue&type=template&id=041cdf68"
import script from "./TouristsSelector.vue?vue&type=script&lang=js"
export * from "./TouristsSelector.vue?vue&type=script&lang=js"
import style0 from "./TouristsSelector.vue?vue&type=style&index=0&id=041cdf68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports